import React from "react";
import MenuClientDetail from "components/RelationClientDetail/MenuClientDetails/MenuClientDetail";
import { styledRelationClientDetail } from "./RelationClientDetailCss";
import CardLeft from "components/RelationClientDetail/InfoClient/CardLeft";
import CardRight from "components/RelationClientDetail/InfoClient/CardRight";
import "./Style.css"
import { useParams } from "react-router-dom";
// import { useGetVoyageursQuery } from "services/Voyageurservices";
import { useSelector } from "react-redux";
// import { useGetReservationsQuery } from "services/ReservationService";
import { useGetVoyageursQuery } from "actions/Voyageurservices";
import { useGetReservationsQuery } from "actions/ReservationService";

const RelationClientDetail = () => {
  const { id } = useParams();
  const idAsInt = parseInt(id, 10);
  // Id hotelier connecté
  const userId = useSelector((state) => state.auth.user_id);
  const { data: voyageursData } = useGetVoyageursQuery(userId);
  const voyageurs = voyageursData?.data || [];
  const client = voyageurs.find((voyageur) => idAsInt === voyageur.id);

  const { data: reservationsData } = useGetReservationsQuery( userId )
  const reservations = reservationsData?.data || [];
  const IdVoyageursReservations = reservations.map((reservation) => reservation.voyageur_details.id)
  console.log({ IdVoyageursReservations });
  const IdVoyageurReservations = IdVoyageursReservations.filter((IdVoyageurReservation) => client.id === IdVoyageurReservation);
  return (
    <div className="container-fluid py-5 relationClient mt-5" style={styledRelationClientDetail.relationClient}>
      <div className="row justify-content-around mt-3 px-3">
        <div className="col-12 col-md-3">
          <CardLeft client={client} />
        </div>
        <div className="col-12 col-md-6 px-4">
          <MenuClientDetail client={client} IdVoyageurReservations={IdVoyageurReservations} />
        </div>
        <div className="col-12 col-md-3">
          <CardRight client={client} />
        </div>
      </div>
    </div>
  )
}

export default RelationClientDetail